/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TicketDialogComponent } from 'src/app/components/ticket-dialog/ticket-dialog.component';
import { ErrorLevel, ErrorType, HomeAway, OddsValidationMode, TicketPlayType, TypeOfPlaceBetTicket } from 'src/app/models/enums';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { BonusService } from 'src/app/services/bonus.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { CashOutService } from 'src/app/services/cash-out.service';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { EventsService } from 'src/app/services/events.service';
import { FreeBetService } from 'src/app/services/freeBet.service';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TicketProviderService } from 'src/app/services/providers/ticket.provider.service';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { TicketManagerTicketService } from 'src/app/ticket-manager/services/ticket-manager-ticket.service';
import { TicketManagerUserService } from 'src/app/ticket-manager/services/ticketManagerUser.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
declare let $: any;

@Component({
  selector: 'app-ticket-dialog-mobile-v2',
  templateUrl: './ticket-dialog-mobile-v2.component.html',
  styleUrls: ['.././ticket-mobile.component.less']
})
export class TicketDialogMobileV2Component extends TicketDialogComponent implements OnInit, AfterViewInit {
  today: Date = new Date();
  CV = ConstantValues;
  public ticketPlayTypeEnum = TicketPlayType;
  public placeBetTypeEnum = TypeOfPlaceBetTicket;
  public showTicketDialogV2 = true;
  public showPayoutInfos = false;
  public showSystemOptions = false;
  enumsHomeAway = HomeAway;

  public taxBeforeStakeDefinitionPercent;
  constructor(
    protected notificationService: NotificationService,
    protected ticketService: TicketService,
    protected ticketProvider: TicketProviderService,
    protected userService: UserService,
    protected utilityService: UtilityService,
    protected storageService: StorageService,
    protected modelMapper: ModelMapperService,
    protected bonusService: BonusService,
    protected freeBetService: FreeBetService,
    protected changesUpdater: ChangesUpdaterService,
    protected cacheChangesService: CacheChangesService,
    protected loaderService: LoaderService,
    protected ticketManagerUserService: TicketManagerUserService,
    protected eventsService: EventsService,
    protected authentificationService: AuthenticationService,
    public cashOutService: CashOutService,
    protected router: Router,
    protected ticketServiceTM: TicketManagerTicketService) {
    super(notificationService, ticketService, ticketProvider, userService, utilityService, storageService, modelMapper, bonusService, freeBetService, changesUpdater, cacheChangesService, loaderService, ticketManagerUserService, authentificationService, cashOutService, router, ticketServiceTM);
    this.subscription.add(this.ticketService.changedOddsAccepted$.subscribe(() => this.placeBetWithTypeOfBetSelected(true)));
  }

  get displayFormat(): string {
    return ConstantValues.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE;
  }

  placeBetWithTypeOfBetSelected(dontCheckAddedOddsChange: boolean = false) {
    if (!dontCheckAddedOddsChange && this.viewConfigurations.showDialogOnOddChangeBeforePlaceBet && this.dialogModel.validationMode === OddsValidationMode.AcceptHigherOdds) {
      for (const eventOrdering of this.orderingForTicketItemGroups) {
        for (const outcomeId of eventOrdering.outcomeIds) {
          if (this.dialogModel.ticketItemEventGroups[eventOrdering.eventId].ticketItems[outcomeId].odd < this.dialogModel.ticketItemEventGroups[eventOrdering.eventId].ticketItems[outcomeId].oldOdd) {
            const notification: ICustomNotification = {
              errorLevel: ErrorLevel.Notification
            } as ICustomNotification;
            notification.errorType = ErrorType.TicketPlaceBetOddChanged;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_OddChangedAfterAddedToTicket;
            this.notificationService.forwardDataToNotification(notification);
            return;
          }
        }
      }
    }


    switch (+this.dialogModel.typeOfPlaceBetTicket) {
      case this.placeBetTypeEnum.Standard:
        this.placeStandardBet();
        break;
      case this.placeBetTypeEnum.Express:
        this.fastTicket();
        break;
      case this.placeBetTypeEnum.FreeBet:
        this.freeBetTicket();
        break;
    }
  }

  expandEvent(group: ITicketItemGroup) {
    if (!group.isLive && group.scores?.length > 0) {
      this.eventsService.expandEventResult(this.modelMapper.mapEventResultFromTicketItemGroup(group, this.languageCulture));
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition && ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent) {
      this.taxBeforeStakeDefinitionPercent = ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent;
    }
  }

  showResult(event) {
    event.currentTarget.offsetParent.children[0].classList.toggle('show');
  }

  openTicketDetails() {
    if (document.getElementsByClassName('ticket-small-wrap').length > 0) {
      const ticketSmall = document.getElementsByClassName('ticket-small-wrap')[0] as HTMLElement;
      ticketSmall.click();
    }
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if ($('app-ticket-dialog-mobile-v2 #ticketWrap .bet-type-name').length > 0) {
        $('app-ticket-dialog-mobile-v2 #ticketWrap .bet-type-name').animate({ scrollLeft: 60}, 600);
        setTimeout(() => {
          $('app-ticket-dialog-mobile-v2 #ticketWrap .bet-type-name').animate({ scrollLeft: 0}, 600);
        }, 600);
        clearInterval(interval);
      }
    }, 100);
  }

}
